<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"
      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList" @on-change="handleChangeStore"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>商品搜索:</label>
          <lk-input class="item" v-model.trim="query.nameMix" :maxlength="50" clearable placeholder="可按名称、编码、助记码搜索"></lk-input>
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in goodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>生产企业:</label>
          <lk-input class="item" v-model.trim="query.producer" :maxlength="50" clearable placeholder="生产厂家"></lk-input>
        </div>
        <div class="queryItem">
          <label>商品状态:</label>
          <lk-select class="item" v-model="query.statusCodeList" clearable>
            <lk-option v-for="(item, index) in goodsStoreStatusList.entries()" :value="item[0]" :key="index">
              {{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>供应商:</label>
          <SupplierListSelect v-model="query.supplierStoreIdList" multiple></SupplierListSelect>
        </div>
        <div class="queryItem">
          <label>数量选择:</label>
          <lk-select class="item" v-model="query.hasGoods" clearable>
            <lk-option v-for="(item, index) in hasGoodsList" :value="item[0]" :key="index">{{ item[1] }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>入库时间:</label>
          <timeStampDatePicker
            class="item"
            type="date"
            clearable
            placeholder="请选择"
            v-model="query.createTimeMs"
           >
          </timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>商品仓库:</label>
          <lk-select class="item" v-model="query.warehouseIds" clearable>
            <lk-option v-for="item in warehouseList" :value="item.id" :key="item.id">
              {{ item.name }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <label>商品标签:</label>
          <lk-select class="item" v-model="query.labelIdList" clearable>
            <lk-option v-for="(item,index) in goodsLabelList" :key="index" :value="item.id">
              {{item.name}}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr" @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset()">重置</lk-button>
        </div>
      </div>
      <div slot="table" class="mt8">
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
    <!-- 冻结和解冻弹出层 开始 -->
    <lk-modal
      v-if="hasInventoryEdit"
      v-model="forzenModal.visiable"
      :mask-closable="false"
      :title="forzenModal.type === 1 ? '冻结' : '解冻'"
      @on-cancel="cancelFrozen"
    >
      <lk-form
        label-position="right"
        :label-width="150"
        :rules="frozenRules"
        :model="frozenModel"
        ref="frozenForm"
      >
        <div class="modalContainer">
          <div v-show="forzenModal.type === 1">
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="当前可冻结数量:" prop="goodsStockNum">
                  <span>{{frozenModel.goodsStockNum}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="原冻结数量:" prop="manualFrozenNum">
                  <span>{{frozenModel.manualFrozenNum}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="本次计划新增冻结数量:" prop="newManualFrozenNum" key="1">
                  <lk-input-number
                    style="width: 100%"
                    :min="0.01"
                    :max="1000000000"
                    :precision="2"
                    :active-change="false"
                    v-model="frozenModel.newManualFrozenNum">
                  </lk-input-number>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </div>
          <div v-show="forzenModal.type === 2">
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="当前冻结数量:" prop="manualFrozenNum">
                  <span>{{frozenModel.manualFrozenNum}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col :span="20">
                <lk-form-item label="本次解冻数量:" prop="newManualFrozenNum" key="2">
                  <lk-input-number
                    style="width: 100%"
                    :min="0.01"
                    :max="999999999.99"
                    :precision="2"
                    :active-change="false"
                    v-model="frozenModel.newManualFrozenNum">
                  </lk-input-number>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </div>
        </div>
      </lk-form>
      <div slot="footer">
        <div>
          <lk-button @click="cancelFrozen">取消</lk-button>
          <lk-button type="primary" @click="handleDoManualFreeze" :loading="forzenModal.loading">提交</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 冻结和解冻弹出层 结束 -->
  </div>
</template>

<script>
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import goods from '../../services/goods';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';

export default {
  name: 'aidInventoryQueryList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    SupplierListSelect,
  },
  computed: {
    goodsTypes() {
      return this.$store.state.publicParams.goodsTypes;
    },
    hasInventoryEdit() {
      return this.handlePermission('aidFakeFreeze') && this.handlePermission('aidFakeUnFreeze');
    },
  },
  data() {
    return {
      goodsStoreStatusList: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      hasGoodsList: new Map().set(1, '有').set(2, '无'),
      goodsLabelList: [],
      query: {
        storeIdList: [], // 门店名称
        nameMix: null, // 商品搜索
        type: null, // 商品类型
        producer: null, // 生产企业
        statusCodeList: [], // 商品状态
        supplierStoreIdList: [], // 供应商
        hasGoods: 1, // 数量选择，1有 2无，默认为1
        createTimeMs: null, // 入库时间
        warehouseIds: [], // 商品仓库
        labelIdList: [], // 商品标签
      },
      forzenModal: { // 控制冻结||解冻弹出层
        visiable: false,
        type: '', // 1冻结 2解冻
        loading: false,
      },
      frozenRules: {
        newManualFrozenNum: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请此处为必填项，不能为空'));
              }
              if (this.forzenModal.type === 1) { // 冻结
                if (value > this.frozenModel.goodsStockNum) {
                  callback(new Error('本次计划新增冻结数量必须小于等于可冻结数量'));
                }
                callback();
              } else {
                if (value > this.frozenModel.manualFrozenNum) {
                  callback(new Error('本次解冻数量必须小于等于当前冻结数量'));
                }
                callback();
              }
            },
          },
        ],
      },
      frozenModel: {
        id: '', // 当前修改的记录
        goodsStockNum: '', // 当前可售数量
        manualFrozenNum: '', // 冻结库存数量
        newManualFrozenNum: null, // 新值
      },
      maintainTypeList: new Map([
        [1, '一般养护'],
        [2, '重点养护'],
      ]),
      paymentTypeList: new Map([
        [1, '普通'],
        [2, '寄售'],
      ]),
      columns: [
        {
          title: '商品编号',
          key: 'drugSerialCode',
          minWidth: 116,
          tooltip: true,
          fixed: 'left',
        },
        {
          title: '商品类型',
          key: 'goodsTypeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '助记码',
          key: 'mnemonicCode',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品名称',
          key: 'goodsName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '通用名称',
          key: 'approvedDrugNames',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '剂型',
          key: 'dosageForm',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '生产厂家',
          key: 'manufacturer',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '产地',
          key: 'countryOfOrigin',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批准文号/注册证号',
          key: 'approvalNumber',
          minWidth: 176,
          tooltip: true,
        },
        {
          title: '商品状态',
          key: 'goodsStoreStatus',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', this.goodsStoreStatusList.get(row.goodsStoreStatus)),
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnit',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '仓库',
          key: 'warehouseName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '货位',
          key: 'locationCode',
          minWidth: 146,
          tooltip: true,
        },
        {
          title: '数量',
          key: 'goodsStockNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '报损冻结数量',
          key: 'breakageFrozenNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '销售冻结数量',
          key: 'saleFrozenNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '库存冻结数量',
          key: 'manualFrozenNum',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '批次',
          key: 'goodsBatchSeq',
          minWidth: 136,
          tooltip: true,
        },
        {
          title: '批号',
          key: 'goodsBatchNumber',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '供应商',
          key: 'supplierName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '生产日期',
          key: 'goodsProductionDate',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', utils.exchangeTime(row.goodsProductionDate)),
        },
        {
          title: '有效期',
          key: 'goodsExpiryDate',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', utils.exchangeTime(row.goodsExpiryDate)),
        },
        {
          title: '安全库存',
          key: 'inventoryWarning',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '养护标准',
          key: 'maintainType',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', this.maintainTypeList.get(row.maintainType)),
        },
        {
          title: '入库时间',
          key: 'createTime',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', utils.exchangeTime(row.createTime)),
        },
        {
          title: '在库天数',
          key: 'inStockDays',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品进价',
          key: 'priceBeforeTax',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '含税金额',
          key: 'taxInclusiveTotalAmount',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '不含税金额',
          key: 'taxExclusiveTotalAmount',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '税金',
          key: 'taxes',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '采购税率',
          key: 'taxRate',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', (`${row.taxRate}%`)),
        },
        {
          title: '零售价格',
          key: 'retailPrice',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '成本类型',
          key: 'payment',
          minWidth: 116,
          tooltip: true,
          render: (h, { row }) => h('span', this.paymentTypeList.get(row.payment)),
        },
        {
          title: '近效期天数',
          key: 'nearlyEffectiveDays',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '商品标签',
          key: 'goodsLabel',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 116,
          render: (h, { row }) => h('div', [
            this.handlePermission('aidFakeFreeze') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.goodsStockNum === 0,
              },
              on: {
                click: () => {
                  this.handleFrozenVisiable(row, 1);
                },
              },
            }, '冻结') : null,
            this.handlePermission('aidFakeUnFreeze') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
                disabled: row.manualFrozenNum === 0,
              },
              on: {
                click: () => {
                  this.handleFrozenVisiable(row, 2);
                },
              },
            }, '解冻') : null,
          ]),
        },
      ],
      tableData: [],
      warehouseList: [],
    };
  },
  methods: {
    getData(isTransform) {
      this.params.page = this.page;
      this.params.size = this.size;
      if (!isTransform) {
        // if (this.params.createTimeMs) {
        //   this.params.createTimeMs = this.params.createTimeMs.getTime();
        // }
        // 后台需要boolean类型数据 1true 2false
        (this.params.hasGoods === 1) && (this.params.hasGoods = true);
        (this.params.hasGoods === 2) && (this.params.hasGoods = false);

        // 后台需要List<Integer>类型数据
        this.params.statusCodeList = [this.params.statusCodeList];
        this.params.warehouseIds = [this.params.warehouseIds];
        this.params.labelIdList = [this.params.labelIdList];
      }
      this.params.purchaseType = 2;
      inventory.getInventoryData(this.params)
        .then((res) => {
          if (res.data.status === 200) {
            this.tableData = [];
            const { count, list } = res.data.data;
            list.forEach((item) => {
              const inventoryItem = item.inventoryInfo;
              inventoryItem.mah = item.goodsInfoVo.mah;
              this.tableData.push(inventoryItem);
            });
            this.count = count;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getWarehouseList(storeListIds = []) {
      const warehouseIdList = this.query.warehouseIdList;
      this.query.warehouseIdList = [];
      inventory.inventoryNameList({ storeIdList: storeListIds })
        .then((res) => {
          if (res.data.status === 200) {
            this.warehouseList = res.data.data;

            // 先选中了A门店，并且选中了该门店下的a仓库，接着选中了B门店，a仓库正常保留，此时清空A门店，a仓库被清空
            const lastWarehouseIndex = this.warehouseList.findIndex(item => item.id === warehouseIdList);
            if (lastWarehouseIndex !== -1 && storeListIds.length) {
              this.query.warehouseIdList = warehouseIdList;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getGoodsLabel() {
      goods.listGoodsLabels()
        .then((res) => {
          if (res.data.status === 200) {
            this.goodsLabelList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    handleChangeStore(storeIdList) {
      this.getWarehouseList(storeIdList);
    },
    handleFrozenVisiable(row, type) {
      this.forzenModal.visiable = true;
      this.forzenModal.type = type;
      this.frozenModel.id = row.id;
      this.frozenModel.goodsStockNum = row.goodsStockNum;
      this.frozenModel.manualFrozenNum = row.manualFrozenNum;
      this.frozenModel.newManualFrozenNum = type === 1 ? row.goodsStockNum : row.manualFrozenNum;
    },
    // 冻结或者解冻操作
    handleDoManualFreeze() {
      this.$refs.frozenForm.validate((valid) => {
        if (valid) {
          this.$store.commit('setDisableLoading', true);
          const params = {
            id: this.frozenModel.id,
            manualFrozenNum: this.frozenModel.newManualFrozenNum,
          };
          const type = this.forzenModal.type;
          const finalFormAction = type === 1 ? inventory.manualFreeze : inventory.manualUnFreeze;
          this.forzenModal.loading = true;
          finalFormAction(params)
            .then((res) => {
              if (res.data.status === 200) {
                this.$Message.success(type === 1 ? '冻结成功' : '解冻成功');
                this.forzenModal.visiable = false;
                this.getData(true);
              } else {
                this.$Message.error(res.data.error);
              }
              this.forzenModal.loading = false;
            })
            .catch((err) => {
              this.forzenModal.loading = false;
              utils.handleError(err);
            });
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    cancelFrozen() {
      this.$refs.frozenForm.resetFields();
      this.forzenModal.visiable = false;
    },
    handleReset() {
      this.query = {};
    },
  },
  created() {
    this.handleSearch(true);
    this.getGoodsLabel(); // 商品标签
    this.getWarehouseList(); // 商品仓库
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }
    console.log(this.hasInventoryEdit, this.handlePermission('aidFakeFreeze'));
    // 没有编辑权限，移除操作列
    if (!this.hasInventoryEdit) {
      this.columns.pop();
    }
  },
};
</script>

<style lang="less" scoped>
  .queryContainer {
    transition: all 1s
  }
</style>
